(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["klekpue_brand_home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('klekpue-brand-home')) {
  customElements.define('klekpue-brand-home', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const listen = (el, event, fn) => el?.addEventListener(event, fn, { signal });
      this.querySelectorAll('[data-gallery]').forEach(gallery => {
        const slides = [...gallery.querySelectorAll('[data-slide]')];
        const thumbs = [...gallery.querySelectorAll('[data-thumb]')];
        let index = 0;
        const show = value => {
          index = (value + slides.length) % slides.length;
          slides.forEach((slide, n) => { slide.hidden = n !== index; });
          thumbs.forEach((thumb, n) => thumb.setAttribute('aria-current', String(n === index)));
          gallery.querySelector('[data-count]').textContent = String(index + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
        };
        show(0);
        listen(gallery.querySelector('[data-prev]'), 'click', () => show(index - 1));
        listen(gallery.querySelector('[data-next]'), 'click', () => show(index + 1));
        thumbs.forEach((thumb, n) => listen(thumb, 'click', () => show(n)));
        listen(gallery, 'keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          show(index + (event.key === 'ArrowRight' ? 1 : -1));
          thumbs[index].focus();
        });
      });
      this.video = this.querySelector('[data-kb-video]');
      const play = this.querySelector('.kb-play-overlay');
      if (this.video && play) {
        const loadVideo = () => {
          if (this.video.dataset.loaded === 'true') return;
          this.video.querySelectorAll('source[data-src]').forEach(source => {
            source.src = source.dataset.src;
          });
          this.video.dataset.loaded = 'true';
          this.video.controls = true;
          this.video.load();
        };
        listen(play, 'click', async () => {
          loadVideo();
          try { await this.video.play(); play.hidden = true; }
          catch { play.hidden = true; this.video.focus(); }
        });
        listen(this.video, 'play', () => { play.hidden = true; });
        listen(this.video, 'ended', () => { play.hidden = false; });
        listen(document, 'visibilitychange', () => { if (document.hidden) this.video.pause(); });
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.video?.pause(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
